export const DefineProperty = (instance: any, key: string, get: () => any, set: (v: any) => void) =>
  // biome-ignore lint/style/noRestrictedGlobals: Object.defineProperty has no tfunc equivalent
  // eslint-disable-next-line no-restricted-globals -- Object.defineProperty has no tfunc equivalent
  Object.defineProperty(instance, key, {
    configurable: true,
    enumerable: true,
    get,
    set,
  })
